import { DEFAULT_MODAL_STATE } from './useModalStore.js';
import { AccountPreviousStep, LoginPreviousStep, ModalStep, SignUpPreviousStep } from '../../utils/steps.js';
export const getActions = (set, get) => ({
    resetState: () => set(DEFAULT_MODAL_STATE),
    setOnModalStepChange: onModalStepChange => set({ onModalStepChange }),
    setStep: step => {
        const onModalStepChange = get().onModalStepChange;
        const previousStep = get().step;
        set({ step });
        onModalStepChange === null || onModalStepChange === void 0 ? void 0 : onModalStepChange({ previousStep, currentStep: step, canGoBack: get().hasPreviousStep() });
    },
    decrementStep: () => {
        const onModalStepChange = get().onModalStepChange;
        const isLogin = get().flow === 'login';
        const isAccount = get().flow === 'account';
        const currentStep = get().step;
        if (currentStep === ModalStep.EX_WALLET_SELECTED) {
            set({ selectedExternalWalletId: undefined, isExternalWalletConnecting: false, externalWalletError: undefined });
        }
        const prevStep = (isAccount ? AccountPreviousStep : isLogin ? LoginPreviousStep : SignUpPreviousStep)[currentStep];
        if (prevStep) {
            set({ step: prevStep, stepDirection: -1 });
            onModalStepChange === null || onModalStepChange === void 0 ? void 0 : onModalStepChange({ previousStep: currentStep, currentStep: prevStep, canGoBack: get().hasPreviousStep() });
        }
    },
    hasPreviousStep: () => {
        const isLogin = get().flow === 'login';
        const isAccount = get().flow === 'account';
        const currentStep = get().step;
        return !!(isAccount
            ? AccountPreviousStep[currentStep]
            : isLogin
                ? LoginPreviousStep[currentStep]
                : SignUpPreviousStep[currentStep]);
    },
    setPopupWindow: popupWindow => {
        set({ popupWindow });
    },
    setFlow: flow => set({ flow }),
    isLogin: () => get().flow === 'login',
    isAccount: () => get().flow === 'account',
    setWebAuthURLForLogin: url => set({ webAuthURLForLogin: url }),
    setWebAuthURLForCreate: url => set({ webAuthURLForCreate: url }),
    setPasswordUrlForCreate: url => set({ passwordUrlForCreate: url }),
    setPasswordUrlForLogin: url => set({ passwordUrlForLogin: url }),
    setSupportedAuthMethods: supportedAuthMethods => set({ supportedAuthMethods }),
    setOnRampPurchase: onRampPurchase => set(state => ({ onRampPurchase: Object.assign(Object.assign({}, (state.onRampPurchase || {})), onRampPurchase) })),
    setOnRampConfig: onRampConfig => set({ onRampConfig }),
    setIsFullyLoggedIn: isFullyLoggedIn => set({ isFullyLoggedIn }),
    setAccountAddFundTab: accountAddFundTab => set({ accountAddFundTab }),
    setSelectedExternalWalletId: selectedExternalWalletId => set({ selectedExternalWalletId }),
    setIsExternalWalletConnecting: isExternalWalletConnecting => set({ isExternalWalletConnecting }),
    setExternalWalletError: externalWalletError => set({ externalWalletError }),
    setIsUsingMobileConnector: isUsingMobileConnector => set({ isUsingMobileConnector }),
    setStepDirection: stepDirection => set({ stepDirection }),
    setActiveWallet: activeWallet => set({ activeWallet }),
    setFarcasterConnectUri: farcasterConnectUri => set({ farcasterConnectUri }),
    setBiometricLocationHints: biometricLocationHints => set({ biometricLocationHints }),
});
